<script setup lang="ts">
import BaseModal from '@/components/base/BaseModal.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { useTemplateRef } from 'vue'

const modalRef = useTemplateRef('modalRef')

const open = () => {
  modalRef.value?.open()
}

const close = () => {
  modalRef.value?.close()
}

const openShop = () => {
  close()
  setTimeout(() => {
    window.open('https://yellowcowries.com/product/financial-wellbeing-playing-cards/', '_blank')
  }, 100)
}

defineExpose({
  open,
  close
})
</script>

<template>
  <BaseModal ref="modalRef" class="lg:px-30">
    <div class="text-center">
      <h2 class="text-xl lg:text-2xl font-bold text-white mb-4 lg:mb-10">Shop</h2>
      <BaseButton background-color="#1AA570" border-color="var(--color-cw-green-border-shadow)" class="md:px-4 md:py-2.5 lg:px-6 lg:py-3.5 lg:mb-10" @click="openShop">
        <p class="w-full !text-sm md:!text-base xl:!text-xl">Get the physical game</p>
      </BaseButton>
    </div>
  </BaseModal>
</template>
